import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ChoferZonasExtendidasEdit } from "./edit";
const EditModal = ChoferZonasExtendidasEdit;
type Entity = models.ChoferZonaExtendidaDto;
type Column = kea.Grid2Column<Entity>;

export interface Props {
    value: Entity[];
    idChofer: number;
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}

export interface BotonesDeps {
    onEliminar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onEliminar
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "300px"
            })
        })
    }
}

export const columnasFijas: Column[] = [
    { title: "Nombre zona extendida", cell: x => ({ data: x.NombreZonaExtendida }) },
];

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}

/**
* Listado de ChoferZonaExtendidaDto
*/
class ChoferZonaExtendidaListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    /**Establece las descripciones de la fila */
    private setDescripciones = async (idChofer: number, idZonaExtendida: number, zonasExtendidas: models.ZonaExtendidaDto[]): Promise<Entity> => {
        const dirCol: Partial<models.ChoferZonaExtendida> = {
            IdChoferZE: idChofer,
            IdZonaExtendida: idZonaExtendida,
        };

        var zonaExtendida = zonasExtendidas.filter(x => x.IdRegistro == idZonaExtendida)[0];
        return { ...dirCol, NombreZonaExtendida: zonaExtendida.Nombre } as Entity;
    }

    onAgregar = async () => {
        var paquetesSeleccionados = this.props.value.map(x => x.IdZonaExtendida);
        const result = await this.modals.showModal(EditModal, undefined, paquetesSeleccionados);
        if (result.result) {
            const idChofer = this.props.idChofer;
            var zonasExtendidas = await resources.ZonaExtendida.query({} as models.FiltroZonaExtendida);

            let data = await Promise.all(result.value.map(async (idZonaExtendida) => {
                const nuevo = await this.setDescripciones(idChofer, idZonaExtendida, zonasExtendidas);
                return nuevo;
            }));
            await this.props.onChange(data);
        }
    }

    onEliminar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.NombreZonaExtendida);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas(this);

        console.log("+++++++++++++++++++++++++++++++++++++++++++++");
        console.log(this);
        

        return (
            <div>
                <kea.Title titulo="Zonas extendidas" onAgregar={this.onAgregar} />
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const ChoferZonaExtendidaList = kea.mapProps(componentToRx(ChoferZonaExtendidaListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuariosze/edit/componentes/zonasextendidas/list.tsx